import { profile } from "../action_types";

const { UPDATE_SESSION, LOADING_PROFILE } = profile;

export function update_session(account, access_token) {
  return {
    type: UPDATE_SESSION,
    account, access_token
  }
}

export function loading_profile(loading) {
  return {
    type: LOADING_PROFILE,
    loading,
  }
}